<template>
  <div
    class="space-y-3 rounded-[2.4rem] border border-black/10 bg-black/[0.02] px-4 py-3"
  >
    <label class="flex items-start gap-3 text-[1.2rem] text-black">
      <input
        id="accept-conditions"
        type="checkbox"
        class="mt-1 h-5 w-5 rounded border-black/20 text-black focus:ring-black"
        :checked="acceptLegal"
        @change="$emit('update:acceptLegal', $event.target.checked)"
      />
      <span class="space-y-1 leading-snug">
        <span class="block">
          {{ $t("By using this site you are accepting our") }}
          <RouterLink
            to="/general-conditions"
            target="_blank"
            class="text-black underline"
          >
            {{ $t("general conditions") }} </RouterLink
          >,
          <a
            href="https://comercial.medkus.com/wayver"
            target="_blank"
            class="text-black underline"
          >
            {{ $t("wayver and release") }} </a
          >,
          <a
            href="https://comercial.medkus.com/privacy"
            target="_blank"
            class="text-black underline"
          >
            {{ $t("privacy policy") }} </a
          >,
          <a
            href="https://comercial.medkus.com/cookies"
            target="_blank"
            class="text-black underline"
          >
            {{ $t("cookie policy") }} </a
          >.
        </span>
      </span>
    </label>
    <label class="flex items-start gap-3 text-[1.2rem] text-black">
      <input
        id="accept-medical"
        type="checkbox"
        class="mt-1 h-5 w-5 rounded border-black/20 text-black focus:ring-black"
        :checked="acceptMedical"
        @change="$emit('update:acceptMedical', $event.target.checked)"
      />
      <span class="leading-snug">
        {{
          $t(
            "I give my consent for Medkus to process my health data in order to use the services",
          )
        }}.
        <a href="#" class="text-black underline" @click.prevent="isOpen = true">
          {{ $t("know more") }}
        </a>
      </span>
    </label>
    <label class="flex items-start gap-3 text-[1.2rem] text-black">
      <input
        id="marketing-opt"
        type="checkbox"
        class="mt-1 h-5 w-5 rounded border-black/20 text-black focus:ring-black"
        :checked="acceptMarketing"
        @change="$emit('update:acceptMarketing', $event.target.checked)"
      />
      <span class="leading-snug">
        {{ $t("I agree to receive advertising or promotional information") }}.
      </span>
    </label>

    <p v-if="legalError" class="text-[1.2rem] text-red-600">
      {{ legalError }}
    </p>

    <PopUp
      :model-value="isOpen"
      size="md"
      :scrollable="true"
      :show-close-button="true"
      @update:model-value="isOpen = $event"
    >
      <div class="p-8 text-[1.4rem] leading-relaxed text-[#3d5a6e]">
        Para poder utilizar nuestra plataforma, es necesario que nos facilites
        determinados datos personales. Utilizamos esta información para
        prestarte nuestros servicios. Dado que parte de estos datos pueden
        incluir información relacionada con tu salud, requerimos tu
        consentimiento expreso. Puedes retirar tu consentimiento en cualquier
        momento; no obstante, en ese caso no podremos continuar ofreciéndote
        nuestros servicios. Cuando realices una reserva, inicies una consulta
        (por chat o videollamada) o interactúes con un especialista, tus datos
        serán compartidos con los profesionales o centros médicos
        correspondientes. Estos tratarán tu información de forma independiente,
        conforme a sus propias políticas de privacidad. Si deseas obtener más
        información sobre cómo gestionamos tus datos, puedes consultar nuestra
        política de privacidad.
      </div>
    </PopUp>
  </div>
</template>

<script>
import PopUp from "@/components/popup/PopUp.vue";
export default {
  name: "CheckoutLegalOptions",
  components: { PopUp },
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    acceptLegal: {
      type: Boolean,
      default: false,
    },
    acceptMedical: {
      type: Boolean,
      default: false,
    },
    acceptMarketing: {
      type: Boolean,
      default: false,
    },
    legalError: {
      type: String,
      default: null,
    },
  },
  emits: [
    "update:acceptLegal",
    "update:acceptMedical",
    "update:acceptMarketing",
  ],
};
</script>
